import { defineComponent as _defineComponent } from 'vue'
import { TaskCard } from './cardSorting';
    import { GoToTaskGroupPage } from '../../../util/UrlUtil';
import Resource from '../../../src/resources/Resource.vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'GroupCard',
  props: {
    taskCard: { type: null, required: true }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as {
        taskCard: TaskCard
    }

    

    function handleClick(card: TaskCard) {
        GoToTaskGroupPage(card.GroupKey, card.GroupMethod);
    }

const __returned__ = { props, handleClick, Resource }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})